import React from 'react'
// @ts-ignore
import CustomFieldPreview from "../../../../../fields/custom/common/form-preview"
import Field2Icon from "./field2-icon"
import ItemId from "../../../../../gd-ui/id/item-id"
import FieldManagementPreview from "../../../../render/management-preview"
import FieldProto from "../../../field-proto"
import ErrorBoundary from "../../../../../error-boundary";

type Props = {
    field       : FieldProto

    children?   : any
}

export default function FieldManagementLeftPanel(props:Props) {

    return (
        <div className="iv-left-column iv-column">
            <ErrorBoundary>


                <Field2Icon field={props.field} />

                <div className="details-item">
                    <div className="label-details ui5-txt-not-important-tiny">Type:</div>
                    <div className="value ui5-txt-default flex-r fl-ac">
                        {props.field.typeLabel}
                    </div>
                </div>


                {!props.field.isNewField &&
                    <div className="details-item">
                        <div className="label-details ui5-txt-not-important-tiny">System ID:</div>
                        <div className="value ui5-txt-default flex-r fl-ac">
                            <ItemId className="m-r-15" renderType="text" itemId={props.field.fieldId} itemName="System" copyId={true} copyUrl={false} />
                        </div>
                    </div>
                }

                <CustomFieldPreview>
                    <FieldManagementPreview field={props.field} />
                </CustomFieldPreview>

                {props.children}

            </ErrorBoundary>


        </div>
    );
}
